import React from 'react';
import { Button, Dialog, DialogActions, DialogTitle } from '@mui/material';
import { Actions, useDispatchProvider, useStateDialogDelete } from '../utils/StateProvider';

const DialogDelete = () => {
  const stateDialogDelete = useStateDialogDelete();
  const dispatch = useDispatchProvider();
  const handleDialogClose = (event, reason) => {
    if (reason === 'backdropClick') return;
    dispatch && dispatch({ type: Actions.DialogDelete, payload: { ...stateDialogDelete, open: false } });
  };

  return (
    <Dialog
      open={stateDialogDelete.open}
      onClose={handleDialogClose}
      aria-describedby="alert-dialog-title"
      maxWidth={'xs'}
      fullWidth={true}
      disableEscapeKeyDown
    >
      <DialogTitle id="alert-dialog-title">{stateDialogDelete.title}</DialogTitle>
      <DialogActions>
        <Button
          onClick={stateDialogDelete.onConfirm}
          color={'primary'}
          variant={'text'}
        >
          Agree
        </Button>
        <Button
          onClick={handleDialogClose}
          autoFocus
          color={'primary'}
          variant={'contained'}
        >
          Disagree
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogDelete;
